import { http, HttpResponse, delay } from 'msw';

import {
  mockedOffboardings,
  simpleMockedOffboardings,
  simpleOffboarding,
  simpleOffboardingsWithStats,
} from '@/mocks/data/offboardingData';
import { requests } from '@/mocks/data/requestData';

export const offboardingHandlers = [
  http.get(
    `*/v1/organizations/:organizationId/offboardings`,
    async ({ request }) => {
      const activeOnly =
        new URL(request.url).searchParams.get('active_only') === 'true';
      const results = activeOnly
        ? simpleOffboardingsWithStats.filter(
            ({ offboarding }) => !offboarding.completed_at
          )
        : simpleOffboardingsWithStats;
      await delay();
      return HttpResponse.json(results, { status: 200 });
    }
  ),
  http.get(
    `*/v1/organizations/:organizationId/offboardings/:offboardingId`,
    async () => {
      if (simpleMockedOffboardings.length > 0) {
        await delay();
        return HttpResponse.json(
          {
            results: simpleMockedOffboardings[0],
          },
          { status: 200 }
        );
      } else {
        return new HttpResponse(null, { status: 404 });
      }
    }
  ),
  http.get(
    `*/v1/organizations/:organizationId/employees/:employeeId/offboarding`,
    async () => {
      await delay();
      // Return 200 + the latest offboarding (or empty body when none exists).
      // The slice's transformResponse treats a falsy body as `undefined`, so the
      // consumer sees "no offboarding" either way. Important: do NOT return 404
      // here — `useGetXboardingStatus` re-triggers this query with
      // `preferCacheValue: false`, so an error result causes the query to be
      // refetched continuously instead of cached.
      if (mockedOffboardings.length > 0) {
        return HttpResponse.json(mockedOffboardings[0], { status: 200 });
      }
      return new HttpResponse(null, { status: 200 });
    }
  ),
  http.get(
    `*/v1/organizations/:organizationId/offboardings/:offboardingId/requests`,
    async () => {
      if (requests.length > 0) {
        await delay();
        return HttpResponse.json(
          {
            results: requests,
          },
          { status: 200 }
        );
      } else {
        return new HttpResponse(null, { status: 404 });
      }
    }
  ),
  http.post(`*/v1/organizations/:organizationId/offboardings`, async () => {
    // add the offboarding to the mock data (mutate the data)
    mockedOffboardings.push(simpleOffboarding);

    await delay();
    return HttpResponse.json(simpleOffboarding, { status: 201 });
  }),
];
